<template>
	<div class="editProfile">
		<div class="vx-row">
			<div class="vx-col w-full xl:w-3/4">
				<vx-card>
					<h1 class="mb-5">{{ $t('clientEditing') }}</h1>
					<div class="vx-row">
						<div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-2">
							<vs-input :label="$t('personName')" name="name" v-validate="'min:3'"
									  v-model="name"/>
							<span
								:class="{ 'text-transparent': !errors.first('name') }"
								class="text-danger text-sm"
							>
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
						<div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-2">
							<vs-input :label="$t('surname')" name="surname" v-validate="'min:3'"
									  v-model="surname"/>
							<span
								:class="{ 'text-transparent': !errors.first('surname') }"
								class="text-danger text-sm"
							>
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
						<div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-2">
							<div class="vs-component vs-con-input-label vs-input vs-input-primary">
								<label class="vs-input--label">{{ $t('sex') }}</label>
								<div class="vs-con-input">
								</div>
								<v-select
									v-model="sex"
									:reduce="country => country.id"
									label="name"
									v-validate="''"
									name="sex"
									:options="genders"
									:dir="$vs.rtl ? 'rtl' : 'ltr'"
									class="single-row-select"
								/>
							</div>
							<span
								:class="{ 'text-transparent': !errors.first('sex') }"
								class="text-danger text-sm"
							>
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
						<div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-2">
							<div class="vs-component vs-con-input-label vs-input vs-input-primary">
								<label class="vs-input--label">{{ $t('country') }}</label>
								<div class="vs-con-input">
								</div>
								<v-select
									v-model="country"
									:reduce="country => country.id"
									label="name"
									v-validate="''"
									name="country"
									:options="countries"
									:dir="$vs.rtl ? 'rtl' : 'ltr'"
									class="single-row-select"
								/>
							</div>
							<span
								:class="{ 'text-transparent': !errors.first('country') }"
								class="text-danger text-sm"
							>
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
						<div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-2">
							<vs-input label="Email" name="email" v-validate="'email|min:3'"
									  v-model="email"/>
							<span
								:class="{ 'text-transparent': !errors.first('email') }"
								class="text-danger text-sm"
							>
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
						<div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-2">
							<vs-input :label="$t('additionalEmail')" name="email_atach" v-validate="'email|min:3'"
									  v-model="email_secondary"/>
							<span
								:class="{ 'text-transparent': !errors.first('email_atach') }"
								class="text-danger text-sm"
							>
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
						<div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-2">
							<vs-phone :label="$t('phone')" name="phone" v-validate="'min:7|max:14'"
									  v-model="phone"/>
							<span
								:class="{ 'text-transparent': !errors.first('phone') }"
								class="text-danger text-sm"
							>
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
						<div class="vx-col hidden sm:block sm:w-1/2 md:hidden"></div>
						<div class="vx-col w-full sm:w-1/2  md:w-1/3 mb-2">
							<vx-input-group>
								<vs-password
									:label="$t('password')"
									data-vv-validate-on="blur"
									v-validate="'min:6|max:32'"
									type="password"
									ref="password"
									name="password"
									v-model="password"
								/>
							</vx-input-group>
							<span
								:class="{ 'text-transparent': !errors.first('password') }"
								class="text-danger text-sm"
							>
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
						<div class="vx-col w-full sm:w-1/2  md:w-1/3 mb-2">
							<vx-input-group>
								<vs-password
									:label="$t('repeatPassword')"
									data-vv-validate-on="blur"
									v-validate="'min:6|max:32'"
									type="password"
									ref="newpassword"
									name="newpassword"
									v-model="newpassword"
								/>
							</vx-input-group>
							<span
								:class="{ 'text-transparent': !errors.first('newpassword') }"
								class="text-danger text-sm"
							>
								{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>
					</div>
					<div class="flex flex-end flex-wrap mb-3 my-5">
						<vs-button @click="saveClient" class="mr-5">
							{{ $t('save') }}
						</vs-button>
						<vs-button color="warning" type="border" @click="$router.go(-1)">{{ $t('cancel') }}</vs-button>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>
<script>
import vSelect from "vue-select";
import notifier from "@/mixins/notifier";

export default {
	mixins: [notifier],
	data() {
		return {
			email: '',
			email_secondary: '',
			name: '',
			surname: '',
			password: '',
			phone: '',
			newpassword: '',
			sex: '',
			country: '',
			user: {},

			countries: [],
			genders: [],
		}
	},
	async mounted () {
		this.countries = (await this.$http.get('/settings/get-countries')).data.data
		this.genders = (await this.$http.get('/settings/get-genders')).data.data

		await this.getUser();

		this.email = this.user.email;
		this.email_secondary = this.user.email_secondary;
		this.name = this.user.first_name;
		this.surname = this.user.last_name;
		this.password = '';
		this.phone = this.user.phone || '';
		this.newpassword = '';
		this.sex = this.user.gender;

		if(this.user.country) this.country = this.user.country;
	},
	methods: {
		async getUser(){
			this.user = (await this.$http.get('/admin/client/view/'+this.$route.params.id)).data.data;
		},
		async saveClient(){
			try {
				let validator = await this.$validator.validateAll();
				if(!validator) return;
				let formData = {
					// "email": this.email,
					// "first_name": this.name,
					// "last_name": this.surname,
					// "email_secondary": this.user.email_secondary,
					// "gender": this.sex,
					// "country": this.country,
					// "phone": this.phone,
				};

				if(this.email !== '' && this.email !== null) {
					formData.email = this.email;
				}
				if(this.email_secondary !== '' && this.email_secondary !== null) {
					formData.email_secondary = this.email_secondary;
				}
				if(this.surname !== '' && this.surname !== null) {
					formData.last_name = this.surname;
				}
				if(this.name !== '' && this.name !== null) {
					formData.first_name = this.name;
				}
				if(this.sex !== '' && this.sex !== null) {
					formData.gender = this.sex;
				}
				if(this.country !== '' && this.country !== null) {
					formData.country = this.country;
				}
				if(this.phone !== '' && this.phone !== null) {
					formData.phone = this.phone;
				}
				if(this.newpassword !== '' && this.newpassword !== null) {
					formData.password = this.newpassword;
				}
				if(this.password !== '' && this.password !== null) {
					formData.password2 = this.password;
				}

				this.newpassword = null;
				this.password = null;

				await this.$http.post('/admin/client/update/'+this.$route.params.id,formData);
				await this.getUser();

				this.notifySuccess(this.$t('dataIsSaved'));
				this.$router.back();

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		toggleShow(ref) {
			let input = this.$refs[ref].$el.querySelector('input');
			input.type = input.type === 'password' ? 'text' : 'password';
		},
	},
	components: {
		'v-select': vSelect,
	},
}
</script>
<style scoped lang="scss">
.vs-con-input-label {
	width: 100%;
}
.vx-input-group .vx-input-group-append .append-text.btn-addon .vs-button{
	height: 38px;
	margin-top: 20px;
}
</style>
